module.exports = __webpack_public_path__ + "static/media/smart.43ab5897.webp";